import { gql } from '@apollo/client';

export const SEND_MESSAGE = gql`
  mutation SendNewMessageFromWebChatbot($input: SendNewMessageInput) {
    sendNewMessageFromWebChatbot(input: $input){
        _id
        facebookPageId
        customer
        message
        timestamp
        userId {
          _id
          name
        }
        senderId
        isLiked
        isDeleted
    }
  }
`;
export const AI_REPLY = gql`
  mutation AiReplyWebChatbot($input: AiReplyWebChatbotInput) {
    aiReplyWebChatbot(input: $input)
  }
`;
export const AI_MESSAGE_LIKE_DISLIKE = gql`
  mutation AiMessageLikeDisLike($input: AiMessageLikeDisLikeInput) {
    aiMessageLikeDisLike(input: $input)
  }
`;

export const UPDATE_CHAT_CONVERSATION = gql`
  mutation UpdateChatConversation($input: UpdateChatConversationInput) {
    updateChatConversation(input: $input)
  }
`;